import {
  UPDATE_USER_INFO,
  UPDATE_USER_TOKEN,
  EMPTY_LOGIN_CLOSE,
  GET_LOGIN_BOX_CLOSE,
} from '../constants/user';
import { cacheKeys } from '../constants/storageKeys';

const initState = {
  userInfo: {},
  userTokenInfo: {},
  loginBoxClose: null,
};

const user = (state = initState, action = {}) => {
  switch (action.type) {
    case UPDATE_USER_INFO:
      localStorage.setItem(cacheKeys.USER_INFO, JSON.stringify(action.userInfo));
      return { ...state, userInfo: action.userInfo };
    case UPDATE_USER_TOKEN:
      return { ...state, userTokenInfo: action.userToken };
    case GET_LOGIN_BOX_CLOSE:
      return { ...state, loginBoxClose: action.userToken };
    case EMPTY_LOGIN_CLOSE:
      return { ...state, loginBoxClose: null };
    default:
      return state;
  }
};

export default user;
